/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { NatsCaller } from "../../NatsCaller";
import type {
  CreateLinkTypeRequest,
  CreateLinkTypeResponse,
  EmptyResponse,
  GetAlmItemTypeForStickyRequest,
  GetAlmItemTypeRequest,
  GetAlmItemTypeResponse,
  GetAlmTypesResponse,
  GetAlmUserResponse,
  GetArtTeamFieldMappingResponse,
  GetDevLinksRequest,
  GetDevLinksResponse,
  GetIterationStatusRequest,
  GetIterationStatusResponse,
  GetMappingResponse,
  GetProjectSourcesResponse,
  GetTeamFieldMappingsResponse,
  IsUserMappedRequest,
  IsUserMappedResponse,
  LoadAlmItemTypesResponse,
  SearchAlmUsersRequest,
  SearchAlmUsersResponse,
  SetAlmTypeRequest,
  SetAlmUserRequest,
  SetArtTeamFieldMappingRequest,
  SetMappingRequest,
  SetTeamFieldMappingsRequest,
  StartIterationSyncRequest,
  StartIterationSyncResponse,
  StartProgramBacklogSyncRequest,
  StartProgramBacklogSyncResponse,
  StartSessionResponse,
  SyncStickyRequest,
} from "./models";
import {
  createLinkTypeResponseSchema,
  emptyResponseSchema,
  getAlmItemTypeResponseSchema,
  getAlmTypesResponseSchema,
  getAlmUserResponseSchema,
  getArtTeamFieldMappingResponseSchema,
  getDevLinksResponseSchema,
  getIterationStatusResponseSchema,
  getMappingResponseSchema,
  getProjectSourcesResponseSchema,
  getTeamFieldMappingsResponseSchema,
  isUserMappedResponseSchema,
  loadAlmItemTypesResponseSchema,
  searchAlmUsersResponseSchema,
  startIterationSyncResponseSchema,
  startProgramBacklogSyncResponseSchema,
  startSessionResponseSchema,
} from "./schemas";

export class NatsAlmsyncJiraClient {
  constructor(private caller: NatsCaller) {}

  async start(session_id: string): Promise<StartSessionResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.sync.start".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "start", {}, startSessionResponseSchema);
  }

  async restart(session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.sync.restart".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "restart", {}, emptyResponseSchema);
  }

  async forceRunning(session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.sync.force.start".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "forceRunning", {}, emptyResponseSchema);
  }

  async setAlmType(payload: SetAlmTypeRequest, session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.alm_type.set".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "setAlmType", payload, emptyResponseSchema);
  }

  async getAlmTypes(session_id: string): Promise<GetAlmTypesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.alm_types.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getAlmTypes", {}, getAlmTypesResponseSchema);
  }

  async getAlmItemType(
    payload: GetAlmItemTypeRequest,
    session_id: string,
  ): Promise<GetAlmItemTypeResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.alm_item_type.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "getAlmItemType",
      payload,
      getAlmItemTypeResponseSchema,
    );
  }

  async getAlmItemTypeForSticky(
    payload: GetAlmItemTypeForStickyRequest,
    session_id: string,
  ): Promise<GetAlmItemTypeResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.alm_item_type.for_sticky.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "getAlmItemTypeForSticky",
      payload,
      getAlmItemTypeResponseSchema,
    );
  }

  async loadAlmItemTypes(session_id: string): Promise<LoadAlmItemTypesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.alm_item_types.load".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "loadAlmItemTypes",
      {},
      loadAlmItemTypesResponseSchema,
    );
  }

  async createLinkType(
    payload: CreateLinkTypeRequest,
    session_id: string,
  ): Promise<CreateLinkTypeResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.link_types.create".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "createLinkType",
      payload,
      createLinkTypeResponseSchema,
    );
  }

  async getJiraSessionTeamFieldMappings(session_id: string): Promise<GetTeamFieldMappingsResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.team_field_mappings.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "getJiraSessionTeamFieldMappings",
      {},
      getTeamFieldMappingsResponseSchema,
    );
  }

  async setJiraSessionTeamFieldMappings(
    payload: SetTeamFieldMappingsRequest,
    session_id: string,
  ): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.team_field_mappings.set".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "setJiraSessionTeamFieldMappings",
      payload,
      emptyResponseSchema,
    );
  }

  async getIterationStatus(
    payload: GetIterationStatusRequest,
    session_id: string,
  ): Promise<GetIterationStatusResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.iterations_sync.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "getIterationStatus",
      payload,
      getIterationStatusResponseSchema,
    );
  }

  async startIterationSync(
    payload: StartIterationSyncRequest,
    session_id: string,
  ): Promise<StartIterationSyncResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.iterations_sync.start".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "startIterationSync",
      payload,
      startIterationSyncResponseSchema,
    );
  }

  async startProgramBacklogSync(
    payload: StartProgramBacklogSyncRequest,
    session_id: string,
  ): Promise<StartProgramBacklogSyncResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.sync_program_backlog.start".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "startProgramBacklogSync",
      payload,
      startProgramBacklogSyncResponseSchema,
    );
  }

  async searchAlmUsers(
    payload: SearchAlmUsersRequest,
    session_id: string,
  ): Promise<SearchAlmUsersResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.alm_users.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "searchAlmUsers",
      payload,
      searchAlmUsersResponseSchema,
    );
  }

  async setAlmUser(payload: SetAlmUserRequest, session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.alm_users.create".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "setAlmUser", payload, emptyResponseSchema);
  }

  async getAlmUser(connection_id: string): Promise<GetAlmUserResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.connections.${connection_id}.user.get".replace(
        "${connection_id}",
        connection_id,
      );
    return await this.caller.request(subject, "getAlmUser", {}, getAlmUserResponseSchema);
  }

  async isUserMapped(
    payload: IsUserMappedRequest,
    connection_id: string,
  ): Promise<IsUserMappedResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.connections.${connection_id}.user.is_mapped.get".replace(
        "${connection_id}",
        connection_id,
      );
    return await this.caller.request(subject, "isUserMapped", payload, isUserMappedResponseSchema);
  }

  async getProjectSources(connection_id: string): Promise<GetProjectSourcesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.connections.${connection_id}.project_sources.get".replace(
        "${connection_id}",
        connection_id,
      );
    return await this.caller.request(
      subject,
      "getProjectSources",
      {},
      getProjectSourcesResponseSchema,
    );
  }

  async getMapping(session_id: string): Promise<GetMappingResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.sprint_mappings.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getMapping", {}, getMappingResponseSchema);
  }

  async setMapping(payload: SetMappingRequest, session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.sprint_mappings.set".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "setMapping", payload, emptyResponseSchema);
  }

  async getArtTeamFieldMapping(
    connection_id: string,
    art_id: string,
  ): Promise<GetArtTeamFieldMappingResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.connections.${connection_id}.arts.${art_id}.team_field_mapping.get"
        .replace("${connection_id}", connection_id)
        .replace("${art_id}", art_id);
    return await this.caller.request(
      subject,
      "getArtTeamFieldMapping",
      {},
      getArtTeamFieldMappingResponseSchema,
    );
  }

  async setArtTeamFieldMapping(
    payload: SetArtTeamFieldMappingRequest,
    connection_id: string,
    art_id: string,
  ): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.connections.${connection_id}.arts.${art_id}.team_field_mapping.set"
        .replace("${connection_id}", connection_id)
        .replace("${art_id}", art_id);
    return await this.caller.request(
      subject,
      "setArtTeamFieldMapping",
      payload,
      emptyResponseSchema,
    );
  }

  async syncSticky(payload: SyncStickyRequest, session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.sticky.sync".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "syncSticky", payload, emptyResponseSchema);
  }

  async getDevLinks(payload: GetDevLinksRequest, session_id: string): Promise<GetDevLinksResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.jira.sessions.${session_id}.dev_links.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getDevLinks", payload, getDevLinksResponseSchema);
  }
}
